define('modules/profiles/profile.module',["client"],
    function(Prospector){
        Prospector.module("ProfileApp", function(ProfileApp, Prospector, Backbone, Marionette, $, _){
            ProfileApp.startWithParent = false;

            ProfileApp.onStart = function(){
                window.utils.rawOutput("starting ProfileApp");
            };

            ProfileApp.onStop = function(){
                window.utils.rawOutput("stopping ProfileApp");
            };
        });

        Prospector.module("Routers.ProfileApp", function(ProfileAppRouter, Prospector, Backbone, Marionette, $, _){
            ProfileAppRouter.Router = Marionette.AppRouter.extend({
                appRoutes: {
                    "profile/:identityType/:sourceId/:refId"    : "profile"
                }
            });
            //API variables and functions that call tasks
            var API = {
                profile: function(identityType, sourceId, refId, options) {
                    var func = $.proxy(function () {
                        sourceId = parseInt(sourceId);
                        require(["modules/profiles/main/profile.controller"], function (ProfileController) {
                            window.utils.raygunTrack('profile/'+identityType+'/'+sourceId);
                            ProfileController.loadProfile(identityType, sourceId, refId, options);
                        });
                    }, this);
                    Prospector.trigger("authAcc", func);
                },
                showFullCardModal: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showCard(options);
                    });
                },
                showUpdateContact: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showUpdateContact(options);
                    });
                },
                showUpdateAccount: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showUpdateAccount(options);
                    });
                },
                showUnlinkContact: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showUnlinkContact(options);
                    });
                },
                showDeleteContact: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showDeleteContact(options);
                    });
                },
                showUnlinkAccount: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showUnlinkAccount(options);
                    });
                },
                showDeleteAccount: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showDeleteAccount(options);
                    });
                },
                showCreateAccount: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showCreateAccount(options);
                    });
                },
                showCreateContact: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showCreateContact(options);
                    });
                },
                showBoardCommentsModal: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showBoardComments(options);
                    });
                },
                showCreateCard: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showCreateCard(options);
                    });
                },
                showCreateArticle: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showCreateArticle(options);
                    });
                },
                showFollowingConfirm: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showFollowingConfirm(options);
                    });
                },
                showFollowingLimit: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showFollowingLimit(options);
                    });
                },
                showWebResearchConfirm: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showWebResearchConfirm(options);
                    });
                },
                showSaveGroupedArticles: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showSaveGroupedArticles(options);
                    });
                },
                showHideGroupedArticles: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showHideGroupedArticles(options);
                    });
                },
                showBoardFilter: function(options) {
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showBoardFilter(options);
                    });
                },
                showFavoriteRolesGroupsControl:function(options){
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showFavoriteRolesGroupsControl(options);
                    });
                },
                showRoleMonitoringGroupsControl:function(options){
                    require(["modules/profiles/modals/modals.controller"], function (ProfileModalsController) {
                        ProfileModalsController.showRoleMonitoringGroupsControl(options);
                    });
                },
                showMonitoringRolesNotification:function(options){
                    require(["modules/profiles/notifications/profile.notifications.controllers"], function(NotificationController){
                        NotificationController.showMonitoringRolesNotification(options);
                    });
                }
            };
            Prospector.on("showFullCardModal", function(options){
                API.showFullCardModal(options);
            });
            Prospector.on("showBoardCommentsModal", function(options){
                API.showBoardCommentsModal(options);
            });
            Prospector.on("showCreateCard", function(options){
                API.showCreateCard(options);
            });
            Prospector.on("showCreateArticle", function(options){
                API.showCreateArticle(options);
            });
            Prospector.on("showSaveGroupedArticles", function(options){
                API.showSaveGroupedArticles(options);
            });
            Prospector.on("showUpdateAccount", function(options){
                API.showUpdateAccount(options);
            });
            Prospector.on("showUpdateContactProfile", function(options){
                API.showUpdateContact(options);
            });
            Prospector.on("showUnlinkContactProfile", function(options){
                API.showUnlinkContact(options);
            });
            Prospector.on("showDeleteContactProfile", function(options){
                API.showDeleteContact(options);
            });
            Prospector.on("showUnlinkAccount", function(options){
                API.showUnlinkAccount(options);
            });
            Prospector.on("showDeleteAccount", function(options){
                API.showDeleteAccount(options);
            });
            Prospector.on("showCreateAccount", function(options){
                API.showCreateAccount(options);
            });
            Prospector.on("showCreateContactProfile", function(options){
                API.showCreateContact(options);
            });
            Prospector.on("showFollowingConfirm", function(options){
                API.showFollowingConfirm(options);
            });
            Prospector.on("showFollowingLimit", function(options){
                API.showFollowingLimit(options);
            });
            Prospector.on("showWebResearchConfirm", function(options){
                API.showWebResearchConfirm(options);
            });
            Prospector.on("showHideGroupedArticles", function(options){
                API.showHideGroupedArticles(options);
            });
            Prospector.on("showBoardFilter", function(options){
                API.showBoardFilter(options);
            });
            Prospector.on("showFavoriteRolesGroupsControl", function(options){
                API.showFavoriteRolesGroupsControl(options);
            });
            Prospector.on("showProfileFeedResults", function(identityType, sourceId, refId, options){
                Prospector.navigate("profile/"+identityType+"/"+sourceId+"/"+refId)
                API.profile(identityType, sourceId, refId, options);
            });
            Prospector.on("showMonitoringRolesNotification", function(options){
                API.showMonitoringRolesNotification(options);
            });
            Prospector.on("showRoleMonitoringGroupsControl", function(options){
                API.showRoleMonitoringGroupsControl(options);
            });
            Prospector.addInitializer(function(){
                //Prospector.trigger("loadCss", "assets/css/profile.css");
                new ProfileAppRouter.Router({
                    controller: API
                });
            });
        });
        return Prospector.ProfileAppRouter;
    });
